import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';

interface AISummaryModuleProps {
  variant: 'portfolio' | 'site';
  siteName?: string;
  onAskAI?: () => void;
}

const PORTFOLIO_SUMMARY = '3 critical items across portfolio. INV-07 outage at Desert Sun is highest power impact (2.4 MWh). O&M renewal at Ridgeline due in 12 days.';
const PORTFOLIO_STEPS = [
  'File warranty claim for INV-07 (before repair)',
  'Review O&M contract terms before Ridgeline renewal',
  'Schedule Array B washing at Desert Sun',
];

const SITE_SUMMARY = 'Critical: INV-07 has been offline for 48 hours (est. 2.4 MWh lost). This is the 4th issue in 6 months \u2014 pattern suggests systemic MPPT failure. Warranty expires Feb 2027 (Section 4.2 covers MPPT). Upcoming: O&M contract renewal due Feb 15. Quarterly inspection due Jan 30.';
const SITE_STEPS = [
  'File warranty claim for INV-07 before scheduling repair',
  'Compare INV-07 fault codes to Sungrow Service Bulletin SB-2025-003',
  'Request O&M provider\u2019s renewal proposal (due in 12 days)',
  'Schedule Array B washing (soiling noted in yesterday\u2019s report)',
];

const AISummaryModule: React.FC<AISummaryModuleProps> = ({ variant, onAskAI }) => {
  const isPortfolio = variant === 'portfolio';
  const summary = isPortfolio ? PORTFOLIO_SUMMARY : SITE_SUMMARY;
  const steps = isPortfolio ? PORTFOLIO_STEPS : SITE_STEPS;
  const headerLabel = isPortfolio ? 'AI OVERVIEW' : 'AI BRIEFING';
  const askLabel = isPortfolio ? 'Ask AI a question' : 'Ask about this site';

  return (
    <div
      className="eg-card"
      style={{ borderLeft: '2px solid #17c480' }}
    >
      <div className="p-4 space-y-4">
        {/* Header */}
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-[#17c480]" />
          <span
            className="text-xs font-semibold uppercase tracking-wider"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            {headerLabel}
          </span>
        </div>

        {/* Summary */}
        <div>
          <p
            className="text-xs font-semibold uppercase tracking-wider mb-2"
            style={{ color: 'var(--color-text-muted)' }}
          >
            SUMMARY
          </p>
          <p className="text-sm leading-relaxed" style={{ color: 'var(--color-text-primary)' }}>
            {summary}
          </p>
        </div>

        {/* Recommended Next Steps */}
        <div>
          <p
            className="text-xs font-semibold uppercase tracking-wider mb-2"
            style={{ color: 'var(--color-text-muted)' }}
          >
            RECOMMENDED NEXT STEPS
          </p>
          <ol className="space-y-1.5">
            {steps.map((step, i) => (
              <li key={i} className="flex gap-2 text-sm" style={{ color: 'var(--color-text-primary)' }}>
                <span className="text-[#17c480] font-medium flex-shrink-0">{i + 1}.</span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
        </div>

        {/* Ask AI Button */}
        {onAskAI && (
          <button
            onClick={onAskAI}
            className="flex items-center gap-1 text-sm font-medium text-[#17c480] hover:text-[#17c480]/80 transition-colors"
          >
            {askLabel}
            <ArrowRight className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default AISummaryModule;
